import { isVisible as c } from "../util/TickUtils.js";
import { getEveryNthWithCondition as _ } from "../util/getEveryNthWithCondition.js";
function E(v, d, s, r, h) {
  for (var g = (r || []).slice(), f = d.start, m = d.end, i = 0, e = 1, t = f, z = function() {
    var o = r == null ? void 0 : r[i];
    if (o === void 0)
      return {
        v: _(r, e)
      };
    var S = i, a, u = function() {
      return a === void 0 && (a = s(o, S)), a;
    }, l = o.coordinate, p = i === 0 || c(v, l, u, t, m);
    p || (i = 0, t = f, e += 1), p && (t = l + v * (u() / 2 + h), i += e);
  }, n; e <= g.length; )
    if (n = z(), n) return n.v;
  return [];
}
export {
  E as getEquidistantTicks
};
